// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { createContext } from 'react';

export interface SupportErrorContextValue {
  showSupportError: (message: string) => void;
  hideSupportError: () => void;
  isVisible: boolean;
}

export const SupportErrorContext = createContext<
  SupportErrorContextValue | undefined
>(undefined);
